import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ContextMenu from 'utils/ContextMenu'

import LayerMenu from './LayerMenu'
import LayerMenuButton from './LayerMenuButton'

const styles = {
  root: {},
  contextMenu: {},
  menuButton: {}
}

class LayerContextMenu_ extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      contextMenuPosition: null
    }
  }

  onButtonClick = (event) => {
    // console.debug('onButtonClick', event)

    const { clientX: left, clientY: top } = event

    event.stopPropagation()

    this.setState({
      contextMenuPosition: {
        left,
        top
      }
    })
  }

  onContextMenuClose = () => {
    // console.debug('onContextMenuClose')

    this.setState({
      contextMenuPosition: null
    })
  }

  onSelect = () => {
    // console.debug('LayerContextMenu - onSelect')

    // This will hide the menu after a slight delay
    window.setTimeout(() => {
      this.setState({
        contextMenuPosition: null
      })
    }, 500)
  }

  render = () => {
    const { classes, layerSelected, show, titleid } = this.props

    if (!show) {
      return null
    }

    const { contextMenuPosition } = this.state

    const showMenu = !!contextMenuPosition

    // console.debug('LayerContextMenu - render', titleid, layerSelected, showMenu)

    return (
      <div className={classes.root}>
        <LayerMenuButton
          className={classes.menuButton}
          onClick={this.onButtonClick}
          show={layerSelected}
          titleid={titleid}
        />
        <ContextMenu
          className={classes.contextMenu}
          onClose={this.onContextMenuClose}
          position={contextMenuPosition}
          show={showMenu}
          titleid={titleid}
        >
          <LayerMenu titleid={titleid} onSelect={this.onSelect} />
        </ContextMenu>
      </div>
    )
  }
}

LayerContextMenu_.propTypes = {
  classes: PropTypes.object.isRequired,
  layerSelected: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  titleid: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  const { titleid } = ownProps

  const layerSelected = state.layers?.[titleid]?.selected ?? false

  const props = {
    layerSelected
  }

  return props
}

const LayerContextMenu = (
  withStyles(styles)(
    connect(
      mapStateToProps
    )(LayerContextMenu_)
  )
)

export default LayerContextMenu
